import { ManualOrder } from '../api-clients/api-types'

export const isNullOrUndefined = (property: ManualOrder | undefined): boolean => {
  return property === undefined || property === null
}
